// components/PaymentInstructions.tsx
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuth } from '../../../Hooks/useAuth';

const PaymentInstructions = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    // Disable scrolling when component is mounted
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    // Function to redirect to user's profile
    const redirectToProfile = () => {
        const userId = user?.id;
        if (userId) {
            navigate(`/profile/${userId}`);
        } else {
            /* Removed console statement */
        }
    };

    return (
        <div className="min-h-screen min-w-full bg-surface-secondary flex items-center justify-center overflow-hidden">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="bg-light-default rounded-lg shadow-xl overflow-hidden border border-surface-tertiary">
                    <div className="p-6">
                        <div className="text-center mb-8">
                            <h2 className="text-3xl font-bold text-content-default mb-4">Instructions de paiement</h2>
                            <p className="text-content-secondary">Pour compléter votre inscription Premium, veuillez suivre ces étapes :</p>
                        </div>

                        <div className="space-y-6">
                            <div className="border-l-4 border-primary-secondary/70 pl-4">
                                <h3 className="text-lg font-semibold text-content-default">1. Effectuez le paiement</h3>
                                <p className="text-content-secondary mt-2">
                                    Envoyez le montant correspondant à votre forfait via Orange Money ou Wave au
                                    numéro suivant :
                                </p>
                                <p className="text-xl font-bold text-primary-default mt-2">+221 77 500 00 00</p>
                            </div>

                            <div className="border-l-4 border-primary-secondary/30 pl-4">
                                <h3 className="text-lg font-semibold text-content-default">2. Envoyez votre reçu</h3>
                                <p className="text-content-secondary mt-2">
                                    Après le paiement, envoyez une capture d'écran du reçu via WhatsApp au :
                                </p>
                                <p className="text-xl font-bold text-primary-default mt-2">+221 77 500 00 00</p>
                            </div>

                            <div className="border-l-4 border-primary-secondary/30 pl-4">
                                <h3 className="text-lg font-semibold text-content-default">3. Confirmation</h3>
                                <p className="text-content-secondary mt-2">
                                    Une fois le paiement vérifié, votre compte sera automatiquement mis à niveau
                                    vers la version Premium.
                                </p>
                            </div>
                        </div>

                        <div className="mt-8">
                            <button
                                onClick={redirectToProfile}
                                className="w-full bg-primary-default text-light-default py-3 px-4 rounded-lg font-semibold hover:bg-primary-secondary transition duration-300"
                            >
                                Retour au profil
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentInstructions;
